module.exports = __webpack_public_path__ + "img/arrow-logout-left-alt.80c2f881.svg";